import React from 'react';
import logo from './Color_logo.png';
import logoIcon from './habitaio_icon.png';
import { MdLogout, MdSettingsSuggest, MdAdminPanelSettings, MdClose } from "react-icons/md";
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useUser } from './UserContext';
import { signOut as amplifySignOut } from '@aws-amplify/auth';

function Header() {
  const { userData, isAdmin, viewingAs, setViewingAs } = useUser();
  const address = userData?.address;
  const email = userData?.email;
  const navigate = useNavigate();
  const location = useLocation();

  const toggleSettings = () => {
    console.log("Settings pressed");
    navigate('/settings');
  };

  const goToAdmin = () => {
    navigate('/admin');
  };

  const exitViewingAs = () => {
    setViewingAs(null);
    navigate('/admin');
  };

  const signOut = async () => {
    try {
      sessionStorage.clear();
      localStorage.clear();
      await amplifySignOut();
    } catch (error) {
      console.error('Error signing out: ', error);
    }
  };

  // Determine what to display based on viewing context
  const displayEmail = viewingAs ? viewingAs.accountName : email;
  const displayAddress = viewingAs ? viewingAs.displayName : address;
  const isOnAdminPage = location.pathname === '/admin';

  return (
  <div className="App">
    <header className="App-header">
      <div className="left-content">
        <Link to="/">
                <img src={logo} className="App-logo App-logo-desktop" alt="logo" />
                <img src={logoIcon} className="App-logo App-logo-mobile" alt="logo" />
        </Link>
        <div className="text-container">
          <p>{viewingAs ? 'Viewing as' : 'My Habitaio'}</p>
          <div className="user-details">
            <span>{displayEmail}</span>
            {displayAddress && displayAddress !== displayEmail && (
              <span>{displayAddress}</span>
            )}
          </div>
        </div>
      </div>
      <div className="right-content">
        {/* Show exit button when viewing as another user */}
        {viewingAs && (
          <button
            className="admin-exit-btn"
            onClick={exitViewingAs}
            title="Exit viewing mode"
          >
            <MdClose /> Exit
          </button>
        )}

        {/* Show admin button for admin users (not when on admin page) */}
        {isAdmin && !isOnAdminPage && !viewingAs && (
          <button className="admin-btn" onClick={goToAdmin} title="Admin panel">
            <MdAdminPanelSettings />
          </button>
        )}

        <button className="settings" onClick={toggleSettings}><MdSettingsSuggest /></button>
        <button className="sign-out" onClick={signOut}><MdLogout /></button>
      </div>
    </header>
  </div>
  );
}

export default Header;